import React from "react";

const defaultBehavior = {
    isAllowedTo: () => false
};

const PermissionContext = React.createContext(defaultBehavior);

export default PermissionContext;
